<div class="FormsImport">
    <div>
        <p>{{ 'forms-data-import.text-import' | locTranslate }}</p>
        <p>{{ 'forms-data-import.text-skip' | locTranslate }}</p>
        <app-forms-place-picker (valueChange)="placeData = $event;"></app-forms-place-picker>
    </div>
    <div class="pt-3" role="status" aria-live="polite">
        @if (placeData == null) {
            <span>
                {{ 'forms-data-import.selection-empty' | locTranslate }}
            </span>
        }
        @if (placeData != null) {
            <span [innerHTML]=" 'forms-data-import.selection-value' | locTranslate:'name':placeData.name:'address':placeData.formatted_address ">
            </span>
        }
    </div>
    <div class="FormsImport-Buttons pt-3">
        <button type="button" class="btn btn-secondary mx-2" (click)="skipImport()">
            <i class="fa-regular fa-undo" aria-hidden="true"></i>
            <span>{{ 'forms-data-import.button-skip' | locTranslate }}</span>
        </button>
        <button type="button" class="btn btn-primary mx-2" [disabled]="placeData == null" (click)="doImport()">
            <i class="fa-regular fa-download" aria-hidden="true"></i>
            <span>{{ 'forms-data-import.button-import' | locTranslate }}</span>
        </button>
    </div>
</div>
